<template>
  <div class="intern">

    <!-- Hero -->
    <header class="intern__hero">
      <div class="intern__hero-overlay"></div>
      <div class="intern__hero-inner">
        <div class="intern__hero-bells">
          <i class="fas fa-bell intern__bell"></i>
          <i class="fas fa-bell intern__bell"></i>
        </div>
        <h1 class="intern__hero-title">{{ $t('blog.recruitmentAnnouncement') }}</h1>
        <p class="intern__hero-sub">
          <i class="fas fa-bolt"></i>
          {{ $t('blog.intern') }}
          <i class="fas fa-bolt"></i>
        </p>
      </div>
      <!-- Wave -->
      <div class="intern__hero-wave">
        <svg viewBox="0 0 1440 80" fill="none" preserveAspectRatio="none">
          <path d="M0,0 C480,80 960,80 1440,0 L1440,80 L0,80 Z" fill="#f2f0ea"/>
        </svg>
      </div>
    </header>

    <div class="intern__body">

      <!-- Company badge -->
      <section class="intern__section intern__section--white">
        <div class="intern__shell">
          <div class="intern__company-badge">
            <i class="fas fa-chart-line"></i>
            <h2>{{ $t('tvsi') }}</h2>
            <p>{{ $t('branchSH') }}</p>
          </div>
        </div>
      </section>

      <!-- Positions -->
      <section class="intern__section intern__section--cream">
        <div class="intern__shell">
          <div class="intern__section-header">
            <h3 class="intern__section-title">
              <i class="fas fa-globe"></i>
              {{ $t('blog.recruitmentPosition') }}
            </h3>
          </div>
          <div class="intern__positions">
            <div class="intern__position-card">
              <div class="intern__position-icon intern__position-icon--blue">
                <i class="fas fa-handshake"></i>
              </div>
              <h4>{{ $t('blog.blog3.businessIntern') }}</h4>
              <p>{{ $t('blog.blog3.developSkill') }}</p>
            </div>
            <div class="intern__position-card">
              <div class="intern__position-icon intern__position-icon--green">
                <i class="fas fa-chart-bar"></i>
              </div>
              <h4>{{ $t('blog.blog3.investIntern') }}</h4>
              <p>{{ $t('blog.blog3.investSkill') }}</p>
            </div>
            <div class="intern__position-card">
              <div class="intern__position-icon intern__position-icon--gold">
                <i class="fas fa-bullhorn"></i>
              </div>
              <h4>{{ $t('blog.blog3.marketingIntern') }}</h4>
              <p>{{ $t('blog.blog3.marketingSkill') }}</p>
            </div>
          </div>
        </div>
      </section>

      <!-- Requirements + Benefits -->
      <section class="intern__section intern__section--white">
        <div class="intern__shell">
          <div class="intern__req-grid">

            <!-- Requirements -->
            <div class="intern__req-card intern__req-card--red">
              <h3 class="intern__req-title">
                <span class="intern__req-num">1</span>
                {{ $t('blog.request') }}
              </h3>
              <ul class="intern__req-list">
                <li><i class="fas fa-check-circle"></i>{{ $t('blog.blog3.rq1') }}</li>
                <li><i class="fas fa-check-circle"></i>{{ $t('blog.blog3.rq2') }}</li>
                <li><i class="fas fa-check-circle"></i>{{ $t('blog.blog3.rq3') }}</li>
              </ul>
            </div>

            <!-- Benefits -->
            <div class="intern__req-card intern__req-card--green">
              <h3 class="intern__req-title">
                <span class="intern__req-num">2</span>
                {{ $t('blog.interest') }}
              </h3>
              <ul class="intern__req-list">
                <li><i class="fas fa-star"></i>{{ $t('blog.blog3.ir1') }}</li>
                <li><i class="fas fa-star"></i>{{ $t('blog.blog3.ir2') }}</li>
                <li><i class="fas fa-star"></i>{{ $t('blog.blog3.ir3') }}</li>
                <li><i class="fas fa-star"></i>{{ $t('blog.blog3.ir4') }}</li>
                <li><i class="fas fa-star"></i>{{ $t('blog.blog3.ir5') }}</li>
                <li><i class="fas fa-star"></i>{{ $t('blog.blog3.ir6') }}</li>
              </ul>
            </div>

          </div>
        </div>
      </section>

      <!-- Contact -->
      <section class="intern__contact">
        <div class="intern__shell">
          <div class="intern__contact-header">
            <h3 class="intern__contact-title">{{ $t('blog.blog3.apply') }}</h3>
            <div class="intern__contact-divider"></div>
            <button class="intern__contact-btn" @click="goToContact">
              <i class="fas fa-rocket"></i>
              {{ $t('common.contactNow') }}
              <i class="fas fa-arrow-right"></i>
            </button>
          </div>

          <div class="intern__contact-grid">
            <div class="intern__contact-card">
              <i class="fas fa-envelope"></i>
              <h4>{{ $t('common.email') }}</h4>
              <p>{{ $t('blog.blog3.sendCV') }}</p>
              <a href="mailto:rimht@tvsi.com.vn">rimht@tvsi.com.vn</a>
            </div>

            <a
              href="https://www.google.com/maps/place/115+L%C3%AA+L%E1%BB%A3i"
              target="_blank"
              rel="noopener noreferrer"
              class="intern__contact-card intern__contact-card--link"
            >
              <i class="fas fa-map-marker-alt"></i>
              <h4>{{ $t('common.address') }}</h4>
              <p>{{ $t('blog.blog3.meet') }}</p>
              <span>(Tầng 2) 115 Lê Lợi - Hải Châu - Đà Nẵng</span>
            </a>

            <div class="intern__contact-card">
              <i class="fas fa-phone"></i>
              <h4>{{ $t('contact.hotline') }}</h4>
              <p>{{ $t('blog.blog3.qs') }}</p>
              <a href="tel:+84766726416">+84.766.726.416 - Ms.Rim</a>
            </div>
          </div>
        </div>
      </section>

    </div>
  </div>
</template>

<script src="./blog-content-tts.js"></script>
<style src="./blog-content-tts.scss" lang="scss"></style>
